// Calcula si conviene texto blanco o negro sobre un color/fondo dado,
// para que siempre sea legible sin importar qué tan claro u oscuro sea
// el tema o color elegido.

const hexAContraste = (hex) => {
  if (!hex || typeof hex !== "string" || !hex.startsWith("#")) return null;

  const limpio = hex.replace("#", "");
  const esCorto = limpio.length === 3;

  const r = parseInt(esCorto ? limpio[0] + limpio[0] : limpio.substr(0, 2), 16);
  const g = parseInt(esCorto ? limpio[1] + limpio[1] : limpio.substr(2, 2), 16);
  const b = parseInt(esCorto ? limpio[2] + limpio[2] : limpio.substr(4, 2), 16);

  if ([r, g, b].some((v) => Number.isNaN(v))) return null;

  // Fórmula estándar de luminancia percibida
  const luminancia = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  return luminancia > 0.6 ? "#0f172a" : "#ffffff";
};

// Acepta un color sólido ("#1e40af") o un degradado
// ("linear-gradient(...)") — en el degradado toma el primer color que
// encuentre como referencia para calcular el contraste.
export const colorTextoLegible = (fondo) => {
  if (!fondo || typeof fondo !== "string") return "#ffffff";

  if (fondo.startsWith("#")) {
    return hexAContraste(fondo) || "#ffffff";
  }

  const match = fondo.match(/#[0-9a-fA-F]{3,6}/);
  if (match) {
    return hexAContraste(match[0]) || "#ffffff";
  }

  // No se pudo determinar (ej. "transparent") — blanco es la opción más
  // segura, ya que casi todos los fondos de este sistema son de color.
  return "#ffffff";
};

export default colorTextoLegible;
